import { waitForTransactionReceipt } from "@wagmi/core";
import { setPools } from "../Redux/WallatSlice";
import { config } from "../App";


export async function verifyTransaction(hash) {
  try {
    const resp = await waitForTransactionReceipt(config, { hash });
    return resp;
  } catch (e) {
    throw e;
  }
}
